var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: {
      entity: "lammie",
      id: _vm.id,
      "api-name": "lammieRequests",
      "new-entity": _vm.newLammieRequest
    },
    on: { isDirtyChange: _vm.handleIsDirtyChange },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.requiredRule] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Name" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.name,
                          callback: function($$v) {
                            _vm.$set(doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.plots,
                          disabled: _vm.isLoading,
                          label: "Event",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Plot" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.plotKeyId,
                          callback: function($$v) {
                            _vm.$set(doc, "plotKeyId", $$v)
                          },
                          expression: "doc.plotKeyId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.events,
                          "item-text": "name",
                          "item-value": "id",
                          disabled: _vm.isLoading,
                          label: "Event",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Active From" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.eventId,
                          callback: function($$v) {
                            _vm.$set(doc, "eventId", $$v)
                          },
                          expression: "doc.eventId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.duration,
                          disabled: _vm.isLoading,
                          label: "Duration",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Duration" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.requiredDuration,
                          callback: function($$v) {
                            _vm.$set(doc, "requiredDuration", $$v)
                          },
                          expression: "doc.requiredDuration"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-1",
                        attrs: { label: "Is Reprint?", dense: "" },
                        model: {
                          value: doc.isReprint,
                          callback: function($$v) {
                            _vm.$set(doc, "isReprint", $$v)
                          },
                          expression: "doc.isReprint"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Phys Rep",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.physRep,
                          callback: function($$v) {
                            _vm.$set(doc, "physRep", $$v)
                          },
                          expression: "doc.physRep"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Intended Purpose",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.intendedPurpose,
                          callback: function($$v) {
                            _vm.$set(doc, "intendedPurpose", $$v)
                          },
                          expression: "doc.intendedPurpose"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Powers",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.powers,
                          callback: function($$v) {
                            _vm.$set(doc, "powers", $$v)
                          },
                          expression: "doc.powers"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Notes",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.notes,
                          callback: function($$v) {
                            _vm.$set(doc, "notes", $$v)
                          },
                          expression: "doc.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Lore Codes",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.loreCodes,
                          callback: function($$v) {
                            _vm.$set(doc, "loreCodes", $$v)
                          },
                          expression: "doc.loreCodes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }